import ar from "./ar";
import en from "./en";

/*
 * Product translations (~136 KB en / ~169 KB ar) used to live in
 * locales/{ar,en}.js, which every route loads — so a blog or campaign visitor
 * downloaded the copy for all 17 product pages. Importing this module keeps
 * that payload on the product pages themselves.
 *
 * Keys drop the old "products_" prefix: `t.products_trucks` is now
 * `getProductsText(locale).trucks`.
 */
export const productsByLocale = { ar, en };

export function getProductsText(locale) {
  return productsByLocale[locale] ?? productsByLocale.ar;
}
